import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Send, Users } from "lucide-react";
import api, { formatApiErrorDetail } from "../../lib/api";

export default function LaunchCampaignCard() {
  const [p, setP] = useState(null);
  const [force, setForce] = useState(false);
  const [busy, setBusy] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const load = () => api.get("/admin/campaigns/launch/preview").then((r) => setP(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!p) return null;
  const sent = p.sent?.status === "sent";
  const send = async () => {
    if (!window.confirm(`Send the launch announcement to ${p.total} people now?`)) return;
    setBusy(true);
    try { const { data } = await api.post("/admin/campaigns/launch/send", { force }); toast.success(`Sending to ${data.queued} recipients in the background`); setTimeout(load, 4000); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="bg-white rounded-2xl border border-black/5 p-5 space-y-3" data-testid="launch-campaign-card">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="font-semibold text-sm flex items-center gap-2"><Mail size={16} /> Launch announcement email</h2>
        <span className="text-xs inline-flex items-center gap-1 text-[#0a0d12]/70" data-testid="launch-campaign-count"><Users size={13} /> {p.total} recipients · {p.donors} donors · {p.volunteers} volunteers</span>
      </div>
      <p className="text-xs text-[#0a0d12]/60">One email per address announcing the new site, Book Store, Employment Bridge and community chat. Each person gets their own community-chat link pre-filled with their DKF reference.</p>
      {p.sent && <div className={`text-xs rounded-md px-3 py-2 ${sent ? "bg-green-50 text-green-800" : "bg-amber-50 text-amber-800"}`} data-testid="launch-campaign-status">{sent ? `Sent on ${new Date(p.sent.finished_at).toLocaleString()} to ${p.sent.sent_count} people${p.sent.failed?.length ? ` · ${p.sent.failed.length} failed` : ""} (by ${p.sent.by?.split("@")[0]})` : `Sending started ${new Date(p.sent.started_at).toLocaleString()}…`}</div>}
      <div className="flex flex-wrap items-center gap-3">
        <button type="button" onClick={() => setShowPreview((v) => !v)} className="text-xs font-semibold underline" data-testid="launch-campaign-preview-toggle">{showPreview ? "Hide" : "Preview"} the email</button>
        {p.can_send && (
          <>
            {p.sent && <label className="inline-flex items-center gap-1.5 text-xs cursor-pointer"><input type="checkbox" checked={force} onChange={(e) => setForce(e.target.checked)} data-testid="launch-campaign-force" /> send again to everyone</label>}
            <button type="button" onClick={send} disabled={busy || p.total === 0 || (p.sent && !force)} className="dk-btn-primary !py-2 text-xs disabled:opacity-50" data-testid="launch-campaign-send"><Send size={13} /> {busy ? "Queuing…" : `Send to ${p.total} people`}</button>
          </>
        )}
      </div>
      {showPreview && (
        <div className="border border-black/10 rounded-lg overflow-hidden" data-testid="launch-campaign-preview">
          <div className="bg-[#f8f4e8] px-3 py-2 text-xs"><b>To:</b> {p.sample_to} · <b>Subject:</b> {p.subject}</div>
          <div className="p-4 text-sm prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: p.sample_html }} />
        </div>
      )}
    </div>
  );
}
